import React from "react";
import {
  FaGlobe,
  FaCalendarAlt,
  FaDatabase,
  FaDollarSign,
} from "react-icons/fa";
import "./plan-details.scss";
import OrangeGlobe from "../../../assets/Icons/OrangeGlobe";
import OrangeCalender from "../../../assets/Icons/OrangeCalender";
import ActivationSteps from "../ActivationSteps/ActivationSteps";
import CompatibilityInfo from "../Compatibilty/CompatibilityInfo";
import RefundPolicy from "../RefundPolicy/RefundPolicy";
import { useNavigate } from "react-router-dom";
import { requestEsimPreorder } from "../../../requests/esimAPI";
import { toast } from "react-toastify";


const PlanDetails = ({ selectedPackage }) => {
  const navigate = useNavigate();
  const handleNext = async () => {
    const esimPreorderResult = await requestEsimPreorder(selectedPackage);
    if (esimPreorderResult == null) {
      toast.error("Something went wrong, pleate try again");
      return;
    }

    navigate("/esim/payment-step", { state: { selectedPackage, esimPreorderResult } });
  };

  return (
    <section className="plan-details-section">
      <div className="plan-details-wrapper">
        <div className="header-container">
          <h4 className="plan-heading">Plan Details</h4>
          <button className="buy-now-btn-top" onClick={handleNext}>
            Buy Now
          </button>
        </div>

        <div className="plan-circle">
          <div className="outer-circle">
            <div className="inner-circle">
              <span className="plan-data">
                {selectedPackage?.volume / 1048576} MB
              </span>
              <span className="plan-subtext">
                of {selectedPackage?.volume / 1048576} MB available
              </span>
            </div>
          </div>
        </div>
        <div className="plan-info-boxes">
          <div className="info-box">
            <OrangeGlobe />

            <div className="info-text">
              <span>Countries</span>
              <span>
                {" "}
                <strong>
                  {selectedPackage.locationNetworkList?.length || 1}
                </strong>
              </span>
            </div>
          </div>
          <div className="info-box">
            <OrangeCalender />
            <div className="info-text">
              <span>Validity</span>
              <span>
                {" "}
                <strong>{selectedPackage?.duration || 0}</strong>
              </span>
            </div>
          </div>
          <div className="info-box">
            <FaDatabase className="info-icon" />
            <div className="info-text">
              <span>Data</span>
              <span>
                {" "}
                <strong>{selectedPackage?.volume / 1048576}</strong>
              </span>
            </div>
          </div>
          <div className="info-box">
            <FaDollarSign className="info-icon" />
            <div className="info-text">
              <span>Price</span>
              <span>
                {" "}
                <strong>
                  {selectedPackage?.currencyCode}{" "}
                  {selectedPackage?.price}
                </strong>
              </span>
            </div>
          </div>
        </div>
        <p className="disclaimer">
          Unable to install eSIM? Full refund - no questions Asked
        </p>
      </div>
      <ActivationSteps />
      <CompatibilityInfo />
      <RefundPolicy />
    </section>
  );
};

export default PlanDetails;
